/* eslint-disable camelcase */

import { SWRConfiguration } from "swr";
import { ServerResponse } from "./axiosConfig";
import { useSwr } from "./axiosHVS";

export interface GroupApiResponse<T> {
  data: T[];
  ok: boolean;
  totalCount: number;
}

export interface GroupsDomain {
  operations: string[];
  users: string[];
  id: string;
  name: string;
  is_personal: boolean;
  type: string;
}

const baseKey = "/Groups";

export const useGroups = (
  config: SWRConfiguration,
  params?: {
    pageNr?: number;
    pageSize?: number;
    orderBy?: string;
    Order?: string;
    SearchKey?: string;
    groupType?: string;
  }
): ServerResponse<GroupApiResponse<GroupsDomain>> =>
  useSwr<GroupApiResponse<GroupsDomain>>(
    `${baseKey}?onlyWithUsers=true${
      params?.groupType ? `&groupType=${params?.groupType}` : ""
    }${params?.pageNr ? `&pageNr=${params?.pageNr}` : ""}${
      params?.pageSize ? `&pageSize=${params?.pageSize}` : ""
    }${
      params?.orderBy != null
        ? `&sortFields=${params?.orderBy}&sortOrder=${params?.Order}`
        : ""
    }${params?.SearchKey != null ? `&SearchKey=${params.SearchKey}` : ""}`,
    config
  );
